var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 10.8543H2V4.85725C2 4.30325 2.455 3.85425 2.992 3.85425H21.008C21.1393 3.85397 21.2693 3.87981 21.3905 3.93025C21.5117 3.9807 21.6217 4.05474 21.714 4.14808C21.8063 4.24142 21.8791 4.35219 21.9282 4.47394C21.9773 4.59568 22.0017 4.72598 22 4.85725V10.8543H21V20.8552C21.0004 20.986 20.975 21.1156 20.9253 21.2366C20.8756 21.3576 20.8026 21.4676 20.7104 21.5604C20.6182 21.6532 20.5086 21.7269 20.3879 21.7773C20.2672 21.8277 20.1378 21.8539 20.007 21.8542H3.993C3.8622 21.8539 3.73276 21.8277 3.61207 21.7773C3.49139 21.7269 3.38181 21.6532 3.2896 21.5604C3.19739 21.4676 3.12436 21.3576 3.07467 21.2366C3.02498 21.1156 2.99961 20.986 3 20.8552V10.8543ZM19 10.8543H5V19.8542H19V10.8543ZM4 5.85425V8.85425H20V5.85425H4ZM9 12.8542H15V14.8542H9V12.8542Z",
    fill: "#C6D5FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventory);
export default __webpack_public_path__ + "static/media/icon-inventory.c112426ac719e436d56b419f9baca1cf.svg";
export { ForwardRef as ReactComponent };